import { render, staticRenderFns } from "./UpdateExpiredPassword.vue?vue&type=template&id=57f79f48&scoped=true&lang=true&"
import script from "./UpdateExpiredPassword.vue?vue&type=script&lang=js&"
export * from "./UpdateExpiredPassword.vue?vue&type=script&lang=js&"
import style0 from "./UpdateExpiredPassword.vue?vue&type=style&index=0&id=57f79f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f79f48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VAvatar,VBtn,VCol,VIcon,VListItem,VListItemTitle,VRow,VTextField})
